var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 71.1",
    style: {
      enableBackground: "new 0 0 71.6 71.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5C2881;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.8,
    cy: 35.4,
    r: 35.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.5,52.8c0.3-1,0.5-1.9,0.8-2.9c0.5-1.8,1-3.7,1.5-5.5c0.1-0.3,0-0.7-0.1-0.9c-2.9-5.9-2.8-11.7,0.6-17.3 c2.6-4.3,6.5-6.9,11.4-7.9C41.5,16.7,50,22,52.5,30.6c2.7,9.6-3.4,19.6-13.2,21.6c-3.9,0.8-7.6,0.2-11.1-1.5 c-0.3-0.2-0.8-0.2-1.2-0.1c-2.6,0.6-5.2,1.4-7.8,2C19,52.7,18.8,52.8,18.5,52.8z M22.6,48.7c0.3,0,0.4,0,0.6-0.1 c1.4-0.4,2.8-0.8,4.2-1.1c0.3-0.1,0.8,0,1.1,0.1c3.1,1.8,6.5,2.4,10,1.7c7.6-1.4,12.7-8.6,11.6-16.3C48.7,23.5,38,18,29.3,22.5 c-7.6,3.9-10.1,13.3-5.6,20.5c0.2,0.2,0.2,0.6,0.1,0.9C23.5,45.5,23,47.1,22.6,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.4,43.6c-2-0.2-3.8-0.9-5.4-1.8c-2.4-1.4-4.3-3.3-5.9-5.5c-0.9-1.2-1.7-2.5-1.9-4c-0.3-1.8,0.3-3.3,1.6-4.5 c0.9-0.8,2.4-0.5,2.9,0.6c0.4,0.9,0.7,1.8,1.1,2.6c0.3,0.6,0.2,1.1-0.2,1.6c-0.2,0.2-0.3,0.4-0.5,0.6c-0.7,0.9-0.7,0.9-0.1,1.8 c1.4,2.1,3.2,3.6,5.5,4.6c0.5,0.2,0.8,0.1,1.1-0.3c0.4-0.5,0.8-0.9,1.1-1.4c0.3-0.5,0.7-0.6,1.2-0.3c1.1,0.5,2.2,1.1,3.3,1.6 c0.5,0.2,0.5,0.6,0.5,1.1c-0.2,1.7-1.3,2.9-3,3.3C41.2,43.5,40.8,43.5,40.4,43.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/WP.1c58051b9e67b85b1a6aa5a0d7963593.svg";
export { ForwardRef as ReactComponent };